var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"company-select-title"},[_c('TextOverTooltip',{attrs:{"content":_setup.userInfo.tenantName || '--',"placement":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }